import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    location: "",
    dateFrom: "",
    dateTo: "",
    winterSports: false,
    chronicDiseases: false,
    highRiskSports: false,
    check: false,
    loader: false,
    showModal: false,
    clientName: "",
    clientSurname: "",
    clientPesel: "",
    clientDate: "",
    clientEmail: "",
    clientPhone: "",
    clientTripParticipant: true,
    clientTermsAccept: [],
    clientMarketingAccept: false,
    clientMarketingPhoneAccept: false,
    clientMarketingSmsAccept: false,
    othersParticipants: [],
    step: 1,
    starpacks:[],
    starpacksEvent:[],
    starpack:'',
    starpackEvent:'',
    leadSalesforceId:'',
    productSalesforceId:'',
    calculationToken:'',
    policySummary:{},
    addresses:{},
    clients:[],
    isInIframe: '',
    partner: {},
    partners: [],
    after7pm: false,
    customModal: false,
  },
  mutations: {
    setLocation(state, value) {
      state.location = value;
    },
    setLoader(state, value) {
      state.loader = value;
    },
    setShowModal(state, value) {
      state.showModal = value;
    },
    setDateFrom(state, value){
      state.dateFrom = value;
    },
    setDateTo(state, value){
      state.dateTo = value;
    },
    setWinterSports(state, value) {
      state.winterSports = value;
    },
    setChronicDiseases(state, value) {
      state.chronicDiseases = value;
    },
    setHighRiskSports(state, value) {
      state.highRiskSports = value;
    },
    setClientName(state, value) {
      state.clientName = value;
    },
    setClientSurname(state, value) {
      state.clientSurname = value;
    },
    setclientPesel(state, value) {
      state.clientPesel = value;
    },
    setClientDate(state, value) {
      state.clientDate = value;
    },
    setClientEmail(state, value) {
      state.clientEmail= value;
    },
    setClientPhone(state, value) {
      state.clientPhone = value;
    },
    setClientTripParticipant(state, value) {
      state.clientTripParticipant = value;
    },
    setClientMarketingAccept(state, value) {
      state.clientMarketingAccept = value;
    },
    setClientMarketingPhoneAccept(state, value) {
      state.clientMarketingPhoneAccept = value;
    },
    setClientMarketingSmsAccept(state, value) {
      state.clientMarketingSmsAccept = value;
    },
    setOthersParticipants(state, value) {
      state.othersParticipants= value;
    },
    setStep(state, value) {
      state.step= value;
    },
    setStarpacks(state, value) {
      state.starpacks= value;
    },
    setStarpack(state, value) {
      state.starpack= value;
    },
    setStarpacksEvent(state, value) {
      state.starpacksEvent= value;
    },
    setStarpackEvent(state, value) {
      state.starpackEvent= value;
    },
    setPolicy(state, value) {
      state.policySummary= value;
    },
    setAddresses(state, value) {
      state.addresses= value;
    },
    setClients(state, value) {
      state.clients= value;
    },
    setClientTermsAccept(state, value) {
      state.clientTermsAccept= value;
    },
    setCheck(state, value) {
      state.check= value;
    },
    setLeadSalesforceId(state, value) {
      state.leadSalesforceId= value;
    },
    setProductSalesforceId(state, value) {
      state.productSalesforceId= value;
    },
    setCalculationToken(state, value) {
      state.calculationToken= value;
    },
    setIsInIframe(state, value) {
      state.isInIframe= value;
    },
    setPartner(state, value) {
      state.partner= value;
    },
    setPartners(state, value) {
      state.partners= value;
    },
    setAfter7pm(state, value) {
      state.after7pm= value;
    },
    setShowCustomModal(state, value){
      state.customModal= value;
    }
  }
});
